import visionJson from "./vision.json";
import { iconsAndImages } from "../../assets/images";
import "./visionStyle.scss";
import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect } from "react";

export const SrkVision = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true
    });
  }, []);

  return (
    <section className="p-4" style={{ backgroundColor: "#FFFFFF0D" }}>
      <div
        className="vision-wrapper"
        style={{
          backgroundColor: "#1D3B5F",
          borderRadius: "30px",
        }}
      >
        <div className="container py-5">
          <div className="row align-items-center gy-5">
            <div className="col-12 col-lg-6">
              <h1 className="bebas-neue-regular text-light mb-4 vision-title">
                {visionJson?.title}
              </h1>
              {visionJson?.srkVisionDetails?.map((detail, index) => (
                <div
                  className="d-flex align-items-start gap-3 mb-4"
                  key={index}
                  data-aos="fade-left"
                >
                  <div className="check-circle">
                    ✓
                  </div>
                  <div>
                    <h6 className="text-light fw-bold mb-1 bebas-neue-regular">
                      {detail?.title}
                    </h6>
                    <p
                      className="text-light small mb-0 vision-desc"
                      dangerouslySetInnerHTML={{
                        __html: detail?.subContent,
                      }}
                    />
                  </div>
                </div>
              ))}
            </div>
            <div className="col-12 col-lg-6 text-center">
              <img
                data-aos="fade-right"
                loading="lazy"
                src={iconsAndImages?.[visionJson?.visionImg]}
                alt="srkVision"
                className="img-fluid rounded-4 w-100 shadow vision-img"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};